import {
	UPDATE_POS_TIER,
	SET_POS_TIER,
	RESET_POS_TIER,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
} from './posTiers.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		initialPosTier: {},
		posTier: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
				name: '',
				description: '',
				sortOrder: '',
				externalId: '',
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_POS_TIER: {
			return {
				data: {
					initialPosTier: payload,
					posTier: payload,
				},
			};
		}

		case UPDATE_POS_TIER: {
			return {
				data: {
					...state.data,
					posTier: {
						...state.data.posTier,
						...payload,
					},
				},
			};
		}

		case RESET_POS_TIER: {
			return {
				...defaultState,
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier)
							return {
								...entry,
								...payload,
							};
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
